
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as bulk_45discountsplEgjhfLAvb7ftNIbX0Si9OXm4ybakBdQOhtNsc3eMsMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/bulk-discounts.vue?macro=true";
import { default as checked_45inXaCdE0P1TOVgFlOYPhNMxVZJ27_9ebwCu2EzWZRjVuQMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/checked-in.vue?macro=true";
import { default as member_45discountsrwZszdNLzDzvFwdOllOiRM6E7agWFp_2IM9I6JFZMY8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/member-discounts.vue?macro=true";
import { default as subkrewe_45membership_bH0f1vBVUZO14Mfvkgiw2IXVDvZCwbK3Mb8v8i_c4gMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/subkrewe-membership.vue?macro=true";
import { default as inventoryhwHNF7DLMR_eoWBL3H94RHjqwRlzpnF9POLhVKjld0kMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/inventory.vue?macro=true";
import { default as lineuphWMUe3bFBf1aDZ2T6yNPMYQ2u1tm81QmJwVvzXA_qBMMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup.vue?macro=true";
import { default as lineup_45status_onZExtztmgsN_4yPiQouUt9HFm1cXASw_02ooYrEsUMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup-status.vue?macro=true";
import { default as products6gm_XjlOALq_MRxTZe3w9F0Eqcoa2faSjzKXS86pmnwMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/products.vue?macro=true";
import { default as radio_45listOA_1b5MWV5L3BbC3o5lx_vbDi1qegIJfGO4WjhLsp_8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/radio-list.vue?macro=true";
import { default as transactionsagbFseqBi1kcMlx_dqaaeObN0QD0empcF0zOjk2Z88UMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/admin/transactions.vue?macro=true";
import { default as _errorQ2NcvU8ZXpPmSZw8CHir2hGsgRkQ79JptG6qtWNOifUMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/_error.vue?macro=true";
import { default as aboutjJTQ9g1ouglbx_7UA_xMqmvVSLrS9hASDKNJogwH9cIMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/about.vue?macro=true";
import { default as beacon42qy1ybGLHqh5yKTM1OUwmDKQkW05FyOcDAI7yeTDcJ2EMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/beacon42.vue?macro=true";
import { default as delete_45account0EFLtRDxzPJfR6EYdZVWcO7HVU8oQFWRbkt8xmrKPcsMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/delete-account.vue?macro=true";
import { default as discourse_45ssopfucE_TnFG6_ZfzDMr7_QKK9XRIxUObCzjfk_vl9hPQMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/discourse-sso.vue?macro=true";
import { default as forgot_45password_kFWRP68r1Aa0rmeLDtcmBFJhOT5yoCQCyolgSSCRXcMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/forgot-password.vue?macro=true";
import { default as lineupYT_6uSYSaqjeEReBFdBnToVCJAWsscDezQxAZ1ItENkMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/lineup.vue?macro=true";
import { default as loginT4ZrGjvki_SwIkTR_xTEuy_bCnOH13jR9gR0wMsDh4wMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/login.vue?macro=true";
import { default as logoutfZ6Nl0FIG7OoUepIIFozzOmzS1w_7BReVSi3hXnGUOkMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/logout.vue?macro=true";
import { default as maintenanceBpSkzeH91RMkUpTS2w2MErs7ciuCq_hnZZS1hZP1nWwMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/maintenance.vue?macro=true";
import { default as privacy_45policyLRK8DY_apyRRduf7CgxlgjlXiT9Beg5DpE6r4BbIhx8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/privacy-policy.vue?macro=true";
import { default as signupCKPBXXnzKxchjsRteJ_yPmcIHfEBjHC5cukz3own2J4Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/signup.vue?macro=true";
import { default as signup_45flow5fQnxEwzUC_GQDWIMUkzPcmgyjeMJGo_31PL9nhnMIQMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/signup-flow.vue?macro=true";
import { default as terms_45of_45serviceic0IKkaAXbO_31ki2FlTjUr5nPX2bZfe_mJXvwM1N_EMeta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/terms-of-service.vue?macro=true";
import { default as verify_45emailaysIGolBpVlmSbY2TkrxS9c_D_E5cWjwW7JFjjFMSS8Meta } from "/Users/wouter/prjs/wouter/krewebacchus/pages/verify-email.vue?macro=true";
export default [
  {
    name: "admin-reporting-bulk-discounts",
    path: "/admin/reporting/bulk-discounts",
    meta: bulk_45discountsplEgjhfLAvb7ftNIbX0Si9OXm4ybakBdQOhtNsc3eMsMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/bulk-discounts.vue")
  },
  {
    name: "admin-reporting-checked-in",
    path: "/admin/reporting/checked-in",
    meta: checked_45inXaCdE0P1TOVgFlOYPhNMxVZJ27_9ebwCu2EzWZRjVuQMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/checked-in.vue")
  },
  {
    name: "admin-reporting-lifetimers",
    path: "/admin/reporting/lifetimers",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/lifetimers.vue")
  },
  {
    name: "admin-reporting-member-discounts",
    path: "/admin/reporting/member-discounts",
    meta: member_45discountsrwZszdNLzDzvFwdOllOiRM6E7agWFp_2IM9I6JFZMY8Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/member-discounts.vue")
  },
  {
    name: "admin-reporting-subkrewe-membership",
    path: "/admin/reporting/subkrewe-membership",
    meta: subkrewe_45membership_bH0f1vBVUZO14Mfvkgiw2IXVDvZCwbK3Mb8v8i_c4gMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/subkrewe-membership.vue")
  },
  {
    name: "admin-reporting-vip-passes",
    path: "/admin/reporting/vip-passes",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/reporting/vip-passes.vue")
  },
  {
    name: "admin-captains",
    path: "/admin/captains",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/captains.vue")
  },
  {
    name: "admin-emails",
    path: "/admin/emails",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/emails.vue")
  },
  {
    name: "admin-inventory",
    path: "/admin/inventory",
    meta: inventoryhwHNF7DLMR_eoWBL3H94RHjqwRlzpnF9POLhVKjld0kMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/inventory.vue")
  },
  {
    name: "admin-lineup",
    path: "/admin/lineup",
    meta: lineuphWMUe3bFBf1aDZ2T6yNPMYQ2u1tm81QmJwVvzXA_qBMMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup.vue")
  },
  {
    name: "admin-lineup-status",
    path: "/admin/lineup-status",
    meta: lineup_45status_onZExtztmgsN_4yPiQouUt9HFm1cXASw_02ooYrEsUMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/lineup-status.vue")
  },
  {
    name: "admin-members",
    path: "/admin/members",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/members.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    meta: products6gm_XjlOALq_MRxTZe3w9F0Eqcoa2faSjzKXS86pmnwMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/products.vue")
  },
  {
    name: "admin-radio-list",
    path: "/admin/radio-list",
    meta: radio_45listOA_1b5MWV5L3BbC3o5lx_vbDi1qegIJfGO4WjhLsp_8Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/radio-list.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/settings.vue")
  },
  {
    name: "admin-subkrewes",
    path: "/admin/subkrewes",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/subkrewes.vue")
  },
  {
    name: "admin-transactions",
    path: "/admin/transactions",
    meta: transactionsagbFseqBi1kcMlx_dqaaeObN0QD0empcF0zOjk2Z88UMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/admin/transactions.vue")
  },
  {
    name: "checkin-equipment",
    path: "/checkin/equipment",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/equipment.vue")
  },
  {
    name: "checkin-qrcode",
    path: "/checkin/qrcode",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/qrcode.vue")
  },
  {
    name: "_error",
    path: "/_error",
    meta: _errorQ2NcvU8ZXpPmSZw8CHir2hGsgRkQ79JptG6qtWNOifUMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/_error.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: aboutjJTQ9g1ouglbx_7UA_xMqmvVSLrS9hASDKNJogwH9cIMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/about.vue")
  },
  {
    name: "beacon42",
    path: "/beacon42",
    meta: beacon42qy1ybGLHqh5yKTM1OUwmDKQkW05FyOcDAI7yeTDcJ2EMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/beacon42.vue")
  },
  {
    name: "checkin",
    path: "/checkin",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/checkin/index.vue")
  },
  {
    name: "delete-account",
    path: "/delete-account",
    meta: delete_45account0EFLtRDxzPJfR6EYdZVWcO7HVU8oQFWRbkt8xmrKPcsMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/delete-account.vue")
  },
  {
    name: "discourse-sso",
    path: "/discourse-sso",
    meta: discourse_45ssopfucE_TnFG6_ZfzDMr7_QKK9XRIxUObCzjfk_vl9hPQMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/discourse-sso.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password_kFWRP68r1Aa0rmeLDtcmBFJhOT5yoCQCyolgSSCRXcMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/forgot-password.vue")
  },
  {
    name: "lineup",
    path: "/lineup",
    meta: lineupYT_6uSYSaqjeEReBFdBnToVCJAWsscDezQxAZ1ItENkMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/lineup.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginT4ZrGjvki_SwIkTR_xTEuy_bCnOH13jR9gR0wMsDh4wMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/login.vue")
  },
  {
    name: "logo-test",
    path: "/logo-test",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/logo-test.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutfZ6Nl0FIG7OoUepIIFozzOmzS1w_7BReVSi3hXnGUOkMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/logout.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceBpSkzeH91RMkUpTS2w2MErs7ciuCq_hnZZS1hZP1nWwMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/maintenance.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/notifications.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyLRK8DY_apyRRduf7CgxlgjlXiT9Beg5DpE6r4BbIhx8Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/privacy-policy.vue")
  },
  {
    name: "purchases",
    path: "/purchases",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/purchases.vue")
  },
  {
    name: "register-subkrewe",
    path: "/register-subkrewe",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/register-subkrewe.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/settings.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupCKPBXXnzKxchjsRteJ_yPmcIHfEBjHC5cukz3own2J4Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/signup.vue")
  },
  {
    name: "signup-flow",
    path: "/signup-flow",
    meta: signup_45flow5fQnxEwzUC_GQDWIMUkzPcmgyjeMJGo_31PL9nhnMIQMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/signup-flow.vue")
  },
  {
    name: "subkrewe",
    path: "/subkrewe",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/subkrewe.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/support.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    meta: terms_45of_45serviceic0IKkaAXbO_31ki2FlTjUr5nPX2bZfe_mJXvwM1N_EMeta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/terms-of-service.vue")
  },
  {
    name: "tracking",
    path: "/tracking",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/tracking.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: verify_45emailaysIGolBpVlmSbY2TkrxS9c_D_E5cWjwW7JFjjFMSS8Meta || {},
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/verify-email.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/wouter/prjs/wouter/krewebacchus/pages/index.vue")
  }
]